export default __webpack_public_path__ + "static/media/big_empty.053c6a1a.svg";